import type React from "react";
import { useContext } from "react";

import { useTranslation } from "react-i18next";
import invariant from "ts-invariant";

import { PhoneCallIcon } from "assets";
import { useProfileContext } from "contexts/ProfileContext";
import { useVideoCallContext } from "contexts/VideoCallContext";
import { useVoiceCallContext } from "contexts/VoiceCallContext";
import { CurrentPatientContext } from "utils/contexts";

import { Button } from "../../helpers";

interface Props {
  readonly inDropdown?: boolean;
}

export const PhoneCallButton: React.FC<Props> = ({ inDropdown }) => {
  const { profile } = useProfileContext();
  const { patient } = useContext(CurrentPatientContext);
  const { voiceCallData, setVoiceCallData } = useVoiceCallContext();
  const { callData: videoCallData } = useVideoCallContext();
  const { t } = useTranslation();

  return (
    <Button
      $justifyContent={inDropdown ? "flex-start" : ""}
      style={{ border: inDropdown ? "none" : "" }}
      data-testid="phone-call-button"
      disabled={!!voiceCallData || !!videoCallData}
      onClick={() => {
        invariant(profile);
        setVoiceCallData({
          caller: {
            id: profile.id,
          },
          callee: {
            id: patient.id,
            name: `${patient.first_name} ${patient.last_name}`,
            phone_number: patient.phone_number,
          },
        });
      }}
    >
      <PhoneCallIcon />
      {t("buttons.phone_call")}
    </Button>
  );
};
